/*
 * brand.js - Sets the title and colours to use
 */
'use strict';

Sao.config.title = 'BMG';
Sao.config.icon_colors = '#444,#777,#d9534f'.split(',');
